import React, { useEffect, useMemo, useState } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { deleteCategoryApi, deleteEmailTemplate, deletePackageApi, deleteShippingApi, getCategoriesApi, getEmailTemplate, getPackageEnquiryApi, getPackageSizeApi, getShippingChargeApi } from '../../apiHelper/authService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedCategory, setSelectedEmailTemplate, setSelectedFollowUp, setSelectedPackage, setSelectedShippingCharge } from '../../redux/authModalSlice';
const ShipmentEnquiryV2 = () => {
    const [activeTab, setActiveTab] = useState("ALL");
    const tabOptions = [
        { label: "ALL", value: "ALL" },
        { label: "PENDING", value: "PENDING" },
        { label: "WORK IN PROGRESS", value: "WORK_IN_PROGRESS" },
        { label: "RESOLVED", value: "RESOLVED" },
        { label: "CLOSED", value: "CLOSED" },
    ];

    const tabs = ["ALL", "PENDING", "WORK IN PROGRESS", "RESOLVED", "CLOSED"];
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedShippingId, setSelectedShippingId] = useState(null);
    const [shipmentInquiryLoading, setShipmentInquiryLoading] = useState(false)
    const navigate = useNavigate()

    const [showMessageModal, setShowMessageModal] = useState(false);

    const [messageContent, setMessageContent] = useState("");

    const dispatch = useDispatch()

    const [activeStatus, setActiveStatus] = useState("ALL");

    const [itemsPerPage] = useState(10);


    const { user } = useSelector((state) => state.authModal);
    // const [categories, setCategories] = useState();
    // const [shippingCharges, setShippingCharges] = useState();
    const [enquiryData, setEnquiryData] = useState()



    const fromCountry = user?.from;
    const toCountry = user?.to;




    // console.log("UserData:", fromCountry)

    const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //     const table = $('#dataTable').DataTable({
    //         pageLength: 10,
    //     });
    //     return () => {
    //         table.destroy(true);
    //     };
    // }, []);




    const getPackageEnquiry = async () => {
        setLoading(true);
        setShipmentInquiryLoading(true);


        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const data = await getPackageEnquiryApi({ status: activeTab, package_type: activeStatus });
            // setCategories(data);
            // setShippingCharges(data)
            setEnquiryData(data)
            setShipmentInquiryLoading(false);
            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching email templates.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
            setShipmentInquiryLoading(false);
        }
    };


    useEffect(() => {

        getPackageEnquiry()


    }, [activeTab, activeStatus])

    console.log(enquiryData)



    const [searchQuery, setSearchQuery] = useState("");


    const filteredData = enquiryData?.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const totalItems = filteredData?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    // const currentItems = enquiryData?.slice(startIdx, startIdx + itemsPerPage);
    const currentItems = Array.isArray(filteredData)
        ? filteredData.slice(startIdx, startIdx + itemsPerPage)
        : [];


    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleConfirmDelete = async () => {
        if (!selectedShippingId) return;

        setLoading(true);



        const toastId = toast.loading("Deleting...");

        try {
            const data = await deleteShippingApi(selectedShippingId);
            // getPackageSizes()
            // getShipCharges()

            toast.success("Delted", { id: toastId });
            const modalEl = document.getElementById('exampleModalEdit');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong while fetching categories.",
                { id: toastId }
            );
        } finally {
            setLoading(false);
            // setSelectedCategoryId(null)
        }

    }

    // function stripHtml(html) {
    //     const div = document.createElement('div');
    //     div.innerHTML = html;
    //     return div.textContent || div.innerText || '';
    // }

    // const handleConfirmDelete = async () => {
    //     if (!selectedMailId) return;

    //     setLoading(true);



    //     const toastId = toast.loading("Deleting...");

    //     try {
    //         const data = await deleteEmailTemplate({ id: selectedMailId });
    //         getEmailTemplates()


    //         toast.success("Delted", { id: toastId });
    //         const modalEl = document.getElementById('exampleModalEdit');
    //         const modalBackdrop = document.querySelector('.modal-backdrop');

    //         modalEl.classList.remove('show');
    //         modalEl.style.display = 'none';
    //         modalEl.setAttribute('aria-hidden', 'true');

    //         if (modalBackdrop) modalBackdrop.remove();
    //         document.body.classList.remove('modal-open');
    //         document.body.style.overflow = '';
    //         document.body.style.paddingRight = '';
    //     } catch (err) {
    //         console.error("Fetch Error:", err);

    //         toast.error(
    //             err?.message || "Something went wrong while fetching categories.",
    //             { id: toastId }
    //         );
    //     } finally {
    //         setLoading(false);

    //     }

    // }

    function getTotalVal(taxPercent, internationCharge, localCharge, humanCharge) {
        const subtotal = internationCharge + localCharge + humanCharge;
        const taxAmount = (subtotal * taxPercent) / 100;
        const total = subtotal + taxAmount;
        return total.toFixed(2);
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const getValueByKeyPath = (obj, keyPath) => {
        return keyPath.split(".").reduce((acc, key) => acc?.[key], obj) ?? "";
    };

    const sortedItems = useMemo(() => {
        if (!sortConfig.key) return currentItems;

        return [...currentItems].sort((a, b) => {
            let valA = getValueByKeyPath(a, sortConfig.key);
            let valB = getValueByKeyPath(b, sortConfig.key);

            const isNumberLike = (val) =>
                typeof val === "number" ||
                (typeof val === "string" && /^[\d.,$]+$/.test(val.trim()));

            if (isNumberLike(valA) && isNumberLike(valB)) {
                const parseNumericValue = (val) =>
                    typeof val === "number"
                        ? val
                        : parseFloat(val.replace(/[^0-9.-]+/g, "")) || 0;

                valA = parseNumericValue(valA);
                valB = parseNumericValue(valB);
            } else {
                valA = valA?.toString().toLowerCase() || "";
                valB = valB?.toString().toLowerCase() || "";
            }

            if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
            if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        });
    }, [currentItems, sortConfig]);


    const getSortIcon = (key) => {
        const baseClass = "transition-all duration-300 ease-in-out";

        if (sortConfig.key !== key) {
            // Neutral icon when column is not sorted
            return <Icon icon="lucide:chevrons-up-down" className={`${baseClass} text-muted`} />;
        }

        return sortConfig.direction === "asc" ? (
            <Icon icon="lucide:chevron-up" className={`${baseClass} text-muted`} />
        ) : (
            <Icon icon="lucide:chevron-down" className={`${baseClass} text-muted`} />
        );
    };







    return (
        <>

            {/* <div className="col-xxl-12 mb-16">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">

                    <div className="card-body px-14">
                        <ul
                            className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-8 w-100"
                            role="tablist"
                        >
                            {tabOptions.map((tab) => (
                                <li className="nav-item" key={tab.value} role="presentation">
                                    <button
                                        className={`nav-link px-16 py-10 ${activeTab === tab.value ? "active" : ""}`}
                                        type="button"
                                        role="tab"
                                        onClick={() => setActiveTab(tab.value)}
                                    >
                                        {tab.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div> */}
            <div className="card basic-data-table">

                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">

                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto"
                                name="search"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>




                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>

                        <div className=" overflow-hidden position-relative ">

                            <div className="card-body " style={{ padding: "0px" }}>
                                <ul className="nav focus-tab nav-pills" id="pills-tab-two" role="tablist">

                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeStatus === "ALL" ? "active" : ""}`}
                                            type="button"
                                            onClick={() => setActiveStatus("ALL")}
                                        >
                                          ALL
                                        </button>
                                    </li>

                                    
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeStatus === "CUSTOM" ? "active" : ""}`}
                                            type="button"
                                            onClick={() => setActiveStatus("CUSTOM")}
                                        >
                                            Custom Box
                                        </button>
                                    </li>

                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeStatus === "FCL" ? "active" : ""}`}
                                            type="button"
                                            onClick={() => setActiveStatus("FCL")}
                                        >
                                            FCL
                                        </button>
                                    </li>

                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${activeStatus === "LCL" ? "active" : ""}`}
                                            type="button"
                                            onClick={() => setActiveStatus("LCL")}
                                        >
                                            LCL
                                        </button>
                                    </li>
                                </ul>


                            </div>
                        </div>

                        <div className="position-relative" style={{ minWidth: '180px' }}>
                            <Icon
                                icon="solar:alt-arrow-down-outline"
                                className="position-absolute"
                                style={{
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none',
                                    color: '#6c757d',
                                    zIndex: 1,
                                }}
                            />

                            <select
                                className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                                style={{
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',

                                }}
                                value={activeTab}
                                onChange={(e) => setActiveTab(e.target.value)}
                            >
                                {tabOptions.map((tab) => (
                                    <option key={tab.value} value={tab.value}>
                                        {tab.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>







                </div>
                <div className="card-body">
                    <div className="table-responsive" style={{ minHeight: "50vh" }}>
                        <table className="table vertical-striped-table mb-0">
                            <thead>
                                <tr>

                                    <th scope="col">Date</th>


                                    {/* <th scope="col">	Full Name</th> */}

                                    <th onClick={() => handleSort("full_name")} style={{ cursor: "pointer" }}>
                                        <div className="d-flex align-items-center gap-2">
                                            Full Name
                                            {/* {getSortIcon("full_name")} */}
                                        </div>
                                    </th>

                                    {/* <th scope="col">		Human Resource Charge</th> */}
                                    {/* <th scope="col">		Country Code</th> */}

                                    {/* <th onClick={() => handleSort("country_code")} style={{ cursor: "pointer" }}>
                                        <div className="d-flex align-items-center gap-2">
                                            Country Code {getSortIcon("country_code")}
                                        </div>
                                    </th> */}

                                    {/* <th scope="col">		Mobile Number</th> */}


                                    <th onClick={() => handleSort("mobile_number")} style={{ cursor: "pointer" }}>
                                        <div className="d-flex align-items-center gap-2">
                                            Phone
                                            {/* {getSortIcon("mobile_number")} */}
                                        </div>
                                    </th>

                                    <th onClick={() => handleSort("mobile_number")} style={{ cursor: "pointer" }}>
                                        <div className="d-flex align-items-center gap-2">
                                            Email
                                            {/* {getSortIcon("mobile_number")} */}
                                        </div>
                                    </th>
                                    {/* <th scope="col">			Package Weight (KG)</th> */}

                                    <th onClick={() => handleSort("approx_package_weight")} style={{ cursor: "pointer" }}>
                                        <div className="d-flex align-items-center gap-2">
                                            KG
                                            {/* {getSortIcon("approx_package_weight")} */}
                                        </div>
                                    </th>
                                    <th scope="col">				LWH </th>
                                    <th scope="col">			Message</th>


                                    {/* <th scope="col">			Status</th> */}



                                    <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                                        <div className="d-flex align-items-center gap-2">
                                            Status
                                            {/* {getSortIcon("status")} */}
                                        </div>
                                    </th>



                                    {activeTab !== "CLOSED" &&

                                        <th scope="col">FollowUp</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {shipmentInquiryLoading ? (
                                    <tr>
                                        <td colSpan="10" className="text-center py-20">
                                            <div
                                                className="spinner-border"
                                                role="status"
                                                style={{
                                                    color: "#243E85",
                                                    width: "2rem",
                                                    height: "2rem",
                                                    borderWidth: "0.3em",
                                                }}
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) :
                                    currentItems?.length > 0 ? (


                                        sortedItems?.map((enquiry) => (
                                            <tr key={enquiry.id}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                            {formatDate(enquiry.createdAt)}
                                                        </h6>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            {enquiry.full_name}
                                                        </h6>
                                                    </div>
                                                </td>



                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >

                                                            {
                                                                enquiry?.mobilenumber ? (

                                                                    <>



                                                                        {enquiry?.country_code}-{enquiry.mobile_number}
                                                                    </>
                                                                )


                                                                    : (
                                                                        "N/A"
                                                                    )
                                                            }
                                                        </h6>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >

                                                            {enquiry?.email}
                                                        </h6>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            {enquiry.approx_package_weight} 
                                                        </h6>
                                                    </div>
                                                </td>


                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            {`${enquiry.approx_package_length}X${enquiry.approx_package_width}X${enquiry.approx_package_height} `}
                                                        </h6>
                                                    </div>
                                                </td>


                                                {/* <td>
                                                    <div className="d-flex align-items-center">

                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 text-truncate text-nowrap overflow-hidden "
                                                            style={{ maxWidth: "200px" }}


                                                        >
                                                            {enquiry.message}
                                                        </h6>
                                                    </div>
                                                </td> */}


                                                <td>
                                                    <button
                                                        className="btn btn-link  p-0"
                                                        style={{ color: "#243E85" }}
                                                        onClick={() => {
                                                            setMessageContent(enquiry?.message || "");
                                                            setShowMessageModal(true);
                                                        }}
                                                    >
                                                        View 
                                                    </button>
                                                </td>



                                                <td>
                                                    <span
                                                        className={`${enquiry?.status !== "RESOLVED"
                                                            ? "bg-warning-focus text-warning-main"
                                                            : "bg-warning-focus text-warning-main"
                                                            } px-24 py-4 rounded-pill fw-medium text-sm`}
                                                    >
                                                        {enquiry?.status}
                                                    </span>
                                                </td>





                                                {activeTab !== "CLOSED" &&
                                                    <td>
                                                        <Link
                                                            to={`/add-follow-up`}
                                                            onClick={() => dispatch(setSelectedFollowUp(enquiry))}
                                                            title="Add Follow Up"
                                                            className="d-inline-flex align-items-center gap-2 px-10 py-6 rounded-pill   text-md fw-medium"
                                                            style={{ textDecoration: 'none', color: "#243E85" }}
                                                        >
                                                            <Icon icon="tabler:message-exclamation" className="text-lg" />
                                                            <span className="d-none d-md-inline">Follow Up</span>
                                                        </Link>
                                                    </td>

                                                }
                                            </tr>
                                        ))


                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center py-16 text-muted">
                                                No Enquiry found.
                                            </td>
                                        </tr>
                                    )}
                            </tbody>

                        </table>
                    </div>
                    {filteredData?.length > itemsPerPage &&


                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                            <span>
                                Showing {startIdx + 1} to{" "}
                                {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                                {filteredData?.length} entries
                            </span>
                            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                <li className="page-item">
                                    <button
                                        className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                        onClick={() => goToPage(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        <Icon icon="ep:d-arrow-left" className="text-xl" />
                                    </button>
                                </li>

                                {[...Array(totalPages)].map((_, index) => (
                                    <li className="page-item" key={index}>
                                        <button
                                            className={`page-link ${currentPage === index + 1
                                                ? "bg-primary-600 text-white"
                                                : "bg-primary-50 text-secondary-light"
                                                } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                                            onClick={() => goToPage(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}

                                <li className="page-item">
                                    <button
                                        className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                        onClick={() => goToPage(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        <Icon icon="ep:d-arrow-right" className="text-xl" />
                                    </button>
                                </li>
                            </ul>
                        </div>}
                </div>
            </div>


            {showMessageModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1050,
                    }}
                >
                    <div className="card" style={{ width: "90%", maxWidth: 490 }}>
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">Message</h6>
                            <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => setShowMessageModal(false)}
                            >
                                Close
                            </button>
                        </div>
                        <div className="card-body" style={{maxHeight:"60vh", overflowY:"auto"}}>
                            {messageContent ? (
                                <p style={{ whiteSpace: "pre-wrap" }}>{messageContent}</p>
                            ) : (
                                <p className="text-muted">No message provided</p>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div
                className="modal fade"
                id="exampleModalEdit"
                tabIndex={-1}
                aria-labelledby="exampleModalEditLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                Confirm Deletion
                            </h1>
                            <button

                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24 text-center">
                            <p className="mb-4 fs-6 text-secondary">
                                Are you sure you want to delete this item?
                            </p>
                            <div className="d-flex justify-content-center gap-3 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handleConfirmDelete}
                                >
                                    Confirm
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ShipmentEnquiryV2